import {useEffect, useState} from "react";
import {SwalAlertClass} from "core/swalClass";
import Form from "react-bootstrap/Form";
// -
import ConditionalRender from "components/ConditionalRender";
import {MiniQ2MultipleValuesModel, MiniQ2MultipleHasModel} from "./models/MiniQ2Models";
import {compareObjects} from "core/utils/objectUtils";

const MiniQ2FormM = ({item, t, type}) => {
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [values, setValues] = useState({...MiniQ2MultipleValuesModel});
    const [has, setHas] = useState({...MiniQ2MultipleHasModel});
    const styleCenterMiddle = {textAlign: "center", verticalAlign: "middle"};

    useEffect(() => {
        if (!item.id) {
            setValues({...MiniQ2MultipleValuesModel});
            setHas({...MiniQ2MultipleHasModel});
        }
    }, [item]);

    useEffect(() => {
        if (type) {
            if (compareObjects(item.values, MiniQ2MultipleValuesModel)) {
                setValues({...item.values});
                setHas({...item.has});
            } else {
                setValues({...MiniQ2MultipleValuesModel});
                setHas({...MiniQ2MultipleHasModel});
            }
        }
    }, [type])

    const onChangeValues = (e) => {
        let {name, value} = e.target;
        let values_ = {...values};
        values_[name] = parseInt(value);
        setValues({...values_});
    }

    const onChangeCheckHas = (e) => {
        let {name, checked} = e.target;
        name = name.replace("has-", "");
        let has_ = {...has};
        has_[name] = checked;
        setHas({...has_});
        let values_ = {...values};
        switch (name) {
            case "p0_hyst_A":
                values_.p0_hyst_A = checked ? "75" : "0";
                break;
            default:

        }
        setValues({...values_});
    }

    const onBlurValues = (e) => {
        const {title, name} = e.target;
        let value = parseInt(e.target.value)
        let min = parseInt(e.target.min)
        let max = parseInt(e.target.max)
        if (value < min || max < value) {
            Alert.warning(
                title,
                `El valor tiene que estar entre ${min}-${max}`
            )
            let values_ = {...values};
            values_[name] = e.target.dataset.default;
            setValues({...values_});
            e.target.focus();
        }
    }

    const onChangeSensors = (e) => {
        let values_ = {...values};
        values_.confsens = parseInt(e.target.value);
        setValues({...values_});
    }
    return (
        <div className="row">
            <div className="col-12">

                <table className="table table-striped mb-5">
                    <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Descripción</th>
                        <th className="text-center">Parametros</th>
                        <th style={{width: "65px", textAlign: "center"}}>Activos</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Sensores</td>
                        <td>Configurar sensores activos</td>
                        <td>
                            <div className="row">
                                <div className="col-md-7">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="days" className="form-label">Sensor</label>
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-center">
                                    <Form.Select
                                        className="mb-2"
                                        id="confsens"
                                        name="confsens"
                                        value={values.confsens}
                                        onChange={onChangeSensors}
                                        style={{minWidth: "110px"}}
                                    >
                                        <option value="0">Sensor A</option>
                                        <option value="1">Sensor B</option>
                                        <option value="2">Sensor AB</option>
                                    </Form.Select>
                                </div>
                            </div>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td colSpan="4" className="text-end">P0</td>
                    </tr>
                    <tr>
                        <td>Distancia P0</td>
                        <td>Muy corta distancia (0-15cm aprox). Distancia en cm del limite superior de P0 (el inferior es 0cm)</td>
                        <td>
                            <div className="row">
                                <div className="col-md-7">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="dist_p0" className="form-label">Distancia P0 (cm)</label>
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-center">
                                    <input
                                        type="number"
                                        id="dist_p0"
                                        name="dist_p0"
                                        className="mb-2 form-control text-end"
                                        min="0" max="255" step="1"
                                        title="Distancia P0"
                                        data-default="7"
                                        value={values.dist_p0}
                                        onChange={onChangeValues}
                                        onBlur={onBlurValues}
                                        readOnly={!has.dist_p0}
                                    />
                                </div>
                            </div>
                        </td>
                        <td style={styleCenterMiddle}>
                            <div className="form-switch">
                                <input
                                    type="checkbox"
                                    id="has-dist_p0"
                                    name="has-dist_p0"
                                    className="form-check-input"
                                    checked={has.dist_p0}
                                    onChange={onChangeCheckHas}
                                />
                            </div>
                        </td>
                    </tr>
                    <ConditionalRender condition={has.dist_p0}>

                        <tr>
                            <td>Pulsos P0</td>
                            <td>Número de pulsos del tren en P0</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pulsos_p0" className="form-label">Pulsos P0</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pulsos_p0"
                                            name="pulsos_p0"
                                            className="mb-2 form-control text-end"
                                            min="1" max="15" step="1"
                                            title="Pulsos P0"
                                            data-default="7"
                                            value={values.pulsos_p0}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Intervalo P0</td>
                            <td>Intervalo entre pulsos en ms en P0</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="intpuls_p0" className="form-label">Intervalo P0 (ms)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="intpuls_p0"
                                            name="intpuls_p0"
                                            className="mb-2 form-control text-end"
                                            min="1" max="255" step="1"
                                            title="Intervalo P0"
                                            data-default="100"
                                            value={values.intpuls_p0}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Potencia en TX P0</td>
                            <td>Se indica la potencia, la que el emisor va a transmitir en cada zona de medición</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pot_tx_p0" className="form-label">Potencia TX P0</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pot_tx_p0"
                                            name="pot_tx_p0"
                                            className="mb-2 form-control text-end"
                                            min="1" max="100" step="1"
                                            title="Potencia P0"
                                            data-default="100"
                                            value={values.pot_tx_p0}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Umbral en RX P0</td>
                            <td>Se especifica el valor mínimo de la señal en recepción para considerar una medida como válida en cada zona de medición</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pot_rx_p0" className="form-label">Umbral P0 %</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pot_rx_p0"
                                            name="pot_rx_p0"
                                            className="mb-2 form-control text-end"
                                            min="1" max="255" step="1"
                                            title="Umbral RX P0"
                                            data-default="100"
                                            value={values.pot_rx_p0}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                    </ConditionalRender>
                    <tr>
                        <td colSpan="4" className="text-end">P1</td>
                    </tr>
                    <tr>
                        <td>Distancia P1</td>
                        <td>corta distancia (15-30cm aprox). Distancia en cm del límite superior de P1 (el inferior es P0)</td>
                        <td>
                            <div className="row">
                                <div className="col-md-7">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="dist_p1" className="form-label">Distancia P1 (cm)</label>
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-center">
                                    <input
                                        type="number"
                                        id="dist_p1"
                                        name="dist_p1"
                                        className="mb-2 form-control text-end"
                                        min="0" max="255" step="1"
                                        title="Distancia P1"
                                        data-default="7"
                                        value={values.dist_p1}
                                        onChange={onChangeValues}
                                        onBlur={onBlurValues}
                                        readOnly={!has.dist_p1}
                                    />
                                </div>
                            </div>
                        </td>
                        <td style={styleCenterMiddle}>
                            <div className="form-switch">
                                <input
                                    type="checkbox"
                                    id="has-dist_p1"
                                    name="has-dist_p1"
                                    className="form-check-input"
                                    checked={has.dist_p1}
                                    onChange={onChangeCheckHas}
                                />
                            </div>
                        </td>
                    </tr>
                    <ConditionalRender condition={has.dist_p1}>

                        <tr>
                            <td>Pulsos P1</td>
                            <td>Número de pulsos del tren en P1</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pulsos_p1" className="form-label">Pulsos P1</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pulsos_p1"
                                            name="pulsos_p1"
                                            className="mb-2 form-control text-end"
                                            min="1" max="15" step="1"
                                            title="Pulsos P1"
                                            data-default="7"
                                            value={values.pulsos_p1}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Intervalo P1</td>
                            <td>Intervalo entre pulsos en ms en P1</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="intpuls_p1" className="form-label">Intervalo P1 (ms)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="intpuls_p1"
                                            name="intpuls_p1"
                                            className="mb-2 form-control text-end"
                                            min="1" max="255" step="1"
                                            title="Intervalo P1"
                                            data-default="100"
                                            value={values.intpuls_p1}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Potencia en TX P1</td>
                            <td>Se indica la potencia, la que el emisor va a transmitir en cada zona de medición</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pot_tx_p1" className="form-label">Potencia TX P1</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pot_tx_p1"
                                            name="pot_tx_p1"
                                            className="mb-2 form-control text-end"
                                            min="1" max="100" step="1"
                                            title="Potencia P1"
                                            data-default="100"
                                            value={values.pot_tx_p1}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Umbral en RX P1</td>
                            <td>Se especifica el valor mínimo de la señal en recepción para considerar una medida como válida en cada zona de medición</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pot_rx_p1" className="form-label">Umbral P1 %</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pot_rx_p1"
                                            name="pot_rx_p1"
                                            className="mb-2 form-control text-end"
                                            min="1" max="255" step="1"
                                            title="Umbral RX P1"
                                            data-default="100"
                                            value={values.pot_rx_p1}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                    </ConditionalRender>
                    <tr>
                        <td colSpan="4" className="text-end">P2</td>
                    </tr>
                    <tr>
                        <td>Distancia P2</td>
                        <td>Media distancia (30-300cm aprox). Distancia en cm del límite superior de P2 (el inferior es P1)</td>
                        <td>
                            <div className="row">
                                <div className="col-md-7">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="dist_p2" className="form-label">Distancia P2 (cm)</label>
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-center">
                                    <input
                                        type="number"
                                        id="dist_p2"
                                        name="dist_p2"
                                        className="mb-2 form-control text-end"
                                        min="0" max="500" step="1"
                                        title="Distancia P2"
                                        data-default="7"
                                        value={values.dist_p2}
                                        onChange={onChangeValues}
                                        onBlur={onBlurValues}
                                        readOnly={!has.dist_p2}
                                    />
                                </div>
                            </div>
                        </td>
                        <td style={styleCenterMiddle}>
                            <div className="form-switch">
                                <input
                                    type="checkbox"
                                    id="has-dist_p2"
                                    name="has-dist_p2"
                                    className="form-check-input"
                                    checked={has.dist_p2}
                                    onChange={onChangeCheckHas}
                                />
                            </div>
                        </td>
                    </tr>
                    <ConditionalRender condition={has.dist_p2}>

                        <tr>
                            <td>Pulsos P2</td>
                            <td>Número de pulsos del tren en P2</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pulsos_p2" className="form-label">Pulsos P2</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pulsos_p2"
                                            name="pulsos_p2"
                                            className="mb-2 form-control text-end"
                                            min="1" max="15" step="1"
                                            title="Pulsos P2"
                                            data-default="7"
                                            value={values.pulsos_p2}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Intervalo P2</td>
                            <td>Intervalo entre pulsos en ms en P2</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="intpuls_p2" className="form-label">Intervalo P2 (ms)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="intpuls_p2"
                                            name="intpuls_p2"
                                            className="mb-2 form-control text-end"
                                            min="1" max="255" step="1"
                                            title="Intervalo P2"
                                            data-default="100"
                                            value={values.intpuls_p2}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Potencia en TX P2</td>
                            <td>Se indica la potencia, la que el emisor va a transmitir en cada zona de medición</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pot_tx_p2" className="form-label">Potencia TX P2</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pot_tx_p2"
                                            name="pot_tx_p2"
                                            className="mb-2 form-control text-end"
                                            min="1" max="100" step="1"
                                            title="Potencia P2"
                                            data-default="100"
                                            value={values.pot_tx_p2}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Umbral en RX P2</td>
                            <td>Se especifica el valor mínimo de la señal en recepción para considerar una medida como válida en cada zona de medición</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pot_rx_p2" className="form-label">Umbral P2 %</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pot_rx_p2"
                                            name="pot_rx_p2"
                                            className="mb-2 form-control text-end"
                                            min="1" max="255" step="1"
                                            title="Umbral RX P2"
                                            data-default="100"
                                            value={values.pot_rx_p2}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                    </ConditionalRender>
                    <tr>
                        <td colSpan="4" className="text-end">P3</td>
                    </tr>
                    <tr>
                        <td>Distancia P3</td>
                        <td>Larga distancia (300-450cm aprox). Distancia en cm del límite superior de P3 (el inferior es P2)</td>
                        <td>
                            <div className="row">
                                <div className="col-md-7">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="dist_p3" className="form-label">Distancia P3 (cm)</label>
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-center">
                                    <input
                                        type="number"
                                        id="dist_p3"
                                        name="dist_p3"
                                        className="mb-2 form-control text-end"
                                        min="0" max="500" step="1"
                                        title="Distancia P3"
                                        data-default="7"
                                        value={values.dist_p3}
                                        onChange={onChangeValues}
                                        onBlur={onBlurValues}
                                        readOnly={!has.dist_p3}
                                    />
                                </div>
                            </div>
                        </td>
                        <td style={styleCenterMiddle}>
                            <div className="form-switch">
                                <input
                                    type="checkbox"
                                    id="has-dist_p3"
                                    name="has-dist_p3"
                                    className="form-check-input"
                                    checked={has.dist_p3}
                                    onChange={onChangeCheckHas}
                                />
                            </div>
                        </td>
                    </tr>
                    <ConditionalRender condition={has.dist_p3}>

                        <tr>
                            <td>Pulsos P3</td>
                            <td>Número de pulsos del tren en P3</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pulsos_p3" className="form-label">Pulsos P3</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pulsos_p3"
                                            name="pulsos_p3"
                                            className="mb-2 form-control text-end"
                                            min="1" max="15" step="1"
                                            title="Pulsos P3"
                                            data-default="7"
                                            value={values.pulsos_p3}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Intervalo P3</td>
                            <td>Intervalo entre pulsos en ms en P3</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="intpuls_p3" className="form-label">Intervalo P3 (ms)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="intpuls_p3"
                                            name="intpuls_p3"
                                            className="mb-2 form-control text-end"
                                            min="1" max="255" step="1"
                                            title="Intervalo P3"
                                            data-default="100"
                                            value={values.intpuls_p3}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Potencia en TX P3</td>
                            <td>Se indica la potencia, la que el emisor va a transmitir en cada zona de medición</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pot_tx_p3" className="form-label">Potencia TX P3</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pot_tx_p3"
                                            name="pot_tx_p3"
                                            className="mb-2 form-control text-end"
                                            min="1" max="100" step="1"
                                            title="Potencia P3"
                                            data-default="100"
                                            value={values.pot_tx_p3}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                        <tr>
                            <td>Umbral en RX P3</td>
                            <td>Se especifica el valor mínimo de la señal en recepción para considerar una medida como válida en cada zona de medición</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="pot_rx_p3" className="form-label">Umbral P3 %</label>
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="pot_rx_p3"
                                            name="pot_rx_p3"
                                            className="mb-2 form-control text-end"
                                            min="1" max="255" step="1"
                                            title="Umbral RX P3"
                                            data-default="100"
                                            value={values.pot_rx_p3}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                            </td>
                        </tr>
                    </ConditionalRender>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default MiniQ2FormM